import { render } from "./MonthPicker.vue?vue&type=template&id=0482464a&ts=true"
import script from "./MonthPicker.vue?vue&type=script&lang=ts"
export * from "./MonthPicker.vue?vue&type=script&lang=ts"

import "./MonthPicker.vue?vue&type=style&index=0&id=0482464a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__